module.exports = __webpack_public_path__ + "media/images/emblems/Buechegg-Blazono-8ceeffbc7e50d08d91f3e0493743b7a4.png";